import React, { useEffect, useState } from 'react'
import style from './Blogs.module.css';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loading from '../../components/Loading/Loading.jsx';
import NoData from '../../components/NoData/NoData.jsx';
import Masonry from 'react-masonry-css'
import '../../components/headersStyling.css';
import Blog from './Blog';
import { useTranslation } from 'react-i18next';
import { getSectionDetails } from '../../Api/blogApis';
import { getBlogsBySection } from '../../Api/blogApis';
import arrow from '../../assets/icons/dropdownarrow.svg';
import { basename,host_url } from './../../configiration/config';
import { filterLanguage, filterProperties } from './../../utilities/filterFunction';

function Blogs({ location }) {
    const { t, i18n } = useTranslation();

    const { pathname } = useLocation();
    const {slug}= useParams();
    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState();
    const [blogSection, setBlogSection] = useState();
    const [selectedSortBy, setSelectedSortBy] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        // section details
        let blog={...blogSection}
        if(slug){
            getSectionDetails(slug).then(response => {
                if (response.data.status === true) {
                     blog=response.data.data
                    setBlogSection(blog)
                }
            })
            // blog by section
            getBlogsBySection(`${slug}${selectedSortBy ? '&sort=' + selectedSortBy : ''}`).then(response => {
                if (response.data.status === true) {
                    setBlogs(response.data.data)
                }
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });
        }
        // eslint-disable-next-line
    }, [selectedSortBy]);

    const [sortingDropHead, setSortingDropHead] = useState(t('select'));

    const sort = (e) => {
        if(e === 'DESC'){
            setSortingDropHead('Newest');
        }else if(e === 'ASC'){
            setSortingDropHead('Oldest');
        }

        if (e !== 'DESC' && e !== 'ASC') {
            console.log('!!');
        } else {
            setSelectedSortBy(e);
        }
    }
    const breakpointColumnsObj = {
        default: 3,
        1000: 2,
        500: 1
    };

    return (
        <div>
            {/* START OF HEADER SECTION */}
            <div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: blogSection ? `url(${host_url}/${blogSection.image})` : '' }}>
                <div className={`myHeaderContent`}>
                    {blogSection && (
                        <>
                            <h1>{blogSection.locales && blogSection.locales.length >0 && filterLanguage(blogSection.locales)[0].name}</h1>
                            <p>
                                <Link className='homeWord' to={`${basename}/`}>
                                    {t('home')}
                                </Link>
                                /
                                <Link className='homeWord' to={`${basename}/blogs`}>
                                    {t('blog')}
                                </Link>
                                / {blogSection.locales && blogSection.locales.length >0 && filterLanguage(blogSection.locales)[0].name}
                            </p>
                        </>
                    )}
                </div>
            </div>
            {/* END OF HEADER SECTION */}

            <div className={`${style.myCustomContainer} mb-4`}>
                {/* START OF SORTING SECTION */}
                <div className={`${style.sorting} my-3`}>
                    <div className={`${style.searchElement}`}>
                        <span>{t('sort-by')}</span>
                        <div className={`dropdown ${style.mate}`}>
                            <button className="w-100 btn px-2 d-flex justify-content-between align-items-center" type="button" id="cityDropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                {sortingDropHead}
                                <img src={arrow} alt='arrow'/>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <li><span className="dropdown-item d-flex" data-sort='DESC' onClick={() => sort('DESC')}><span>{t('sort-by')} : </span> <span>{t('newest')}</span></span></li>
                                <li><span className="dropdown-item d-flex" data-sort='ASC' onClick={() => sort('ASC')}><span>{t('sort-by')} : </span> <span>{t('oldest')}</span></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* START OF SORTING SECTION */}

                {/* START OF CATEGORY SECTION */}
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className={`${style.my_masonry_grid} ${style.category}`}
                    columnClassName={`${style.my_masonry_grid_column}`}
                >
                    {blogSection && blogs && blogs.map((blog,i) => 
                   { let blogLocale=filterLanguage(blog.locales)
                    let lang;
                    if(i18n.language === 'ar'){
                      lang = 'en'
                    }else if(i18n.language === 'en'){
                      lang = 'ar'
                    }
                    let diferentLanguage = filterProperties(blog.locales,lang)
                       return(
                        <Blog key={i} blog={blog} blogLocale={blogLocale} blogDiffLocale={diferentLanguage} section={blogSection} />
                    )})}
                </Masonry>
                {loading && (
                    <Loading width='100px' height='100px' />
                )}
                {!loading && (!blogs || !blogs.length) &&
                    <NoData text='No available data' />
                }
                {/* END OF CATEGORY SECTION */}
            </div>
        </div>
    )
}

export default Blogs